import { Zap, UserCheck, Tag, Globe, PenLine } from 'lucide-react';
import { CartaoDoNo, EntradaDoNo, SaidaPadrao } from './node-chrome';

/** Ícone por ação — o raio genérico dizia pouco quando o fluxo tinha cinco ações. */
const ICONE: Record<string, any> = {
  'add-tag': Tag,
  add_tag: Tag,
  'remove-tag': Tag,
  remove_tag: Tag,
  'set-field': PenLine,
  update_field: PenLine,
  webhook: Globe,
  webhook_action: Globe,
  assign: UserCheck,
  assign_agent: UserCheck,
  handoff: UserCheck,
};

const TITULO: Record<string, string> = {
  'add-tag': 'Adicionar etiqueta',
  add_tag: 'Adicionar etiqueta',
  'remove-tag': 'Remover etiqueta',
  remove_tag: 'Remover etiqueta',
  'set-field': 'Atualizar campo',
  update_field: 'Atualizar campo',
  webhook: 'Avisar outro sistema',
  webhook_action: 'Avisar outro sistema',
  assign: 'Atribuir a um atendente',
  assign_agent: 'Atribuir a um atendente',
  handoff: 'Passar para atendente',
  update_score: 'Pontuar o contato',
  enroll_in_flow: 'Mandar para outro fluxo',
};

export default function ActionNode({ data }: any) {
  const tipo = String(data.actionType ?? '');
  return (
    <>
      <EntradaDoNo />
      <CartaoDoNo
        tipo="action"
        dados={data}
        icone={ICONE[tipo] ?? Zap}
        corDoTopo="bg-emerald-500"
        corDoIcone="text-emerald-600"
        titulo={data.label || TITULO[tipo] || 'Ação'}
      />
      <SaidaPadrao />
    </>
  );
}
